// src/utils/pixel.js
export const trackCustomEvent = (eventName, eventParams) => {
    if (window.fbq) {
      window.fbq('track', eventName, eventParams);
    }
  };
  